<template>
    <div class="financeApplication__addressSelector">
        <div class="financeApplication__addressSelector__input" v-if="!submitted">
            <FinanceApplicationText
                id="postcode"
                placeholder="Enter Postcode"
                v-model="postcode"
            />
            <button type="button"
                    class="financeApplication__addressSelector__button"
                    :disabled="!isPostcodeValid || isSubmitting"
                    @click="submit"
            >
                Find address
            </button>
        </div>

        <template v-else>
            <div class="financeApplication__addressSelector__input">
                <div class="financeApplication__form__input financeApplication__form__input--select">
                    <select name="address" id="" @change="onAddressChange">
                        <option value="">Please select</option>
                        <option :value="address.id"
                                v-for="address in addressResults"
                                :key="address.id"
                        >
                            {{ formatAddress(address) }}
                        </option>
                    </select>
                </div>
            </div>

            <button type="button" class="financeApplication__addressSelector__clear" @click="onClear">
                Go back to search
            </button>


            <div class="financeApplication__addressSelector__noResults" v-if="addressResults.length === 0">Sorry, we can't find any results with that postcode.</div>

            <button type="button"
                    class="financeApplication__addressSelector__manualAddress"
                    @click="$emit('show-manual-address-form')"
            >
                Can't find your address? Click to enter manually.
            </button>
        </template>

    </div>
</template>

<script>

import FinanceApplicationText from './FinanceApplicationText.vue'
export default {
    components: {
        FinanceApplicationText
    },
    props: {
        initialPostcode: {
            type: String
        },
    },
    data() {
        return {
            postcode: this.initialPostcode,
            submitted: false,
            addressResults: [],
            isSubmitting: false
        }
    },
    methods: {
        formatAddress(address) {
            return address.line_1 +  ' ' + address.line_2 + ' ' + address.city
        },
        async submit() {
            this.addressResults = []

            if (!this.isPostcodeValid) {
                return
            }

            this.isSubmitting = true

            await this.getAddress(this.postcode)

            this.isSubmitting = false
        },
        async getAddress(postcode) {
            try {
                const res = await fetch('/plugins/PAFLookup/ajax/get_address.php?postcode=' + postcode).then((data) => data.json())

                console.log({ res })

                const { addresses } = res

                this.addressResults = addresses
                this.submitted = true
            } catch (e) {
                console.error({ e })
            }
        },
        validatePostcode(postcode) {
            postcode = postcode.replace(/\s/g, '');
            const regex = /^[a-z]{1,2}\d{1,2}[a-z]?\s*\d[a-z]{2}$/i;
            return regex.test(postcode);
        },
        onAddressChange(e) {
            const id = e.target.value
            const address = this.addressResults.find((a) => a.id === id)

            if (address) {
                this.$emit('address-suggestion', {
                    address,
                    postcode: this.postcode
                })
            }
        },
        onClear() {
            this.addressResults = []
            this.submitted = false
            this.postcode = ''
        }
    },
    computed: {
        isPostcodeValid() {
            return this.validatePostcode(this.postcode)
        }
    }
}
</script>